import { TimeZoneItem } from "rpc/auth/AuthRpc";

export class RegisterModel {

    public isInit: boolean = true;

    public companyName: string = "";
    public userName: string = "";
    public email: string = "";
    public password: string = "";
    public timeZone: string = "";

    public timezoneItems: TimeZoneItem[] = [];

    public error: string = null;
    public companyNameError: string = null;
    public userNameError: string = null;
    public emailError: string = null;
    public passwordError: string = null;

}
